export const CABINET_SKU = {
  BASE_SPACER: -1,
  WALL_SPACER: -2,
  VOID_SPACE: -3
};

export const DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
